module.exports = __webpack_public_path__ + "static/img/gouwuche.5732b11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/gouwuche.svg
// module id = ku3K
// module chunks = 66